import { render, staticRenderFns } from "./WidgetPassageCitationTOC.vue?vue&type=template&id=63fbb661&"
import script from "./WidgetPassageCitationTOC.vue?vue&type=script&lang=js&"
export * from "./WidgetPassageCitationTOC.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPassageCitationTOC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetPassageCitationTOC.vue"
export default component.exports